import TargetOrg from './target/Org';
import TargetSelect from './target/TargetSelect';
import OptionSelect from './items/OptionSelect';
import EnterOrg from './enter/Org';
import SelectInput from './enter/SelectInput';
import DataGridMul from './enter/DataGridMul';
import ResultGridMul from './enter/ResultGridMul';
import Target from './result/Target'
import SearchSelect from './result/SearchSelect';
import SearchOrg from './result/SearchOrg';
import College from './enter/College';
import Major from './enter/Major';
import CollageSelect from './target/CollageSelect';
import ResizeTable from './enter/ResizeTable';
import Year from './year/Year';

export default {
    TargetOrg,
    TargetSelect,
    OptionSelect,
    EnterOrg,
    SelectInput,
    DataGridMul,
    Target,
    SearchSelect,
    SearchOrg,
    College,
    Major,
    CollageSelect,
    ResultGridMul,
    ResizeTable,
    Year
}